module.exports = __webpack_public_path__ + "img/calendar.a99ce7ec.svg";